import { render, staticRenderFns } from "./OptionsFilters.vue?vue&type=template&id=2b263e1a&"
import script from "./OptionsFilters.vue?vue&type=script&lang=js&"
export * from "./OptionsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports